export const BinaryInstances = {
  Host: 'Host',
  Installer: 'Installer',
  ModuleBuilder: 'ModuleBuilder',
  StudentQ: 'StudentQ',
  StudentT: 'StudentT',
  GamesNRSWAPractical: 'Games.NRSWAPractical',
};
